/**
 * !!! AUTOGENERATED, DO NOT MODIFY !!!
 *
 * This file is gitignored and regenerated by
 * script/remote_lookup/update-ignored-files.ts via `yarn update-generated-files`.
 *
 * @owner @Appboy/messaging-experience
 *
 * Friendly aliases over the cross-type generated modules for the
 * "custom_event" remote lookup provider. Items are server output (the Output
 * variants); ids and filters are client-constructed input (the unsuffixed
 * variants).
 */
import type { z } from "zod";

import type { RemoteLookupProvider } from "../providers/types";

import type { IdType } from "../../../../cross_type/braze/remote_lookup/providers/custom_event_remote_lookup_provider/id_type.types";
import type { ItemTypeOutput } from "../../../../cross_type/braze/remote_lookup/providers/custom_event_remote_lookup_provider/item_type.types";
import type { FiltersType } from "../../../../cross_type/braze/remote_lookup/providers/custom_event_remote_lookup_provider/filters_type.types";

import { idTypeSchema } from "../../../../cross_type/braze/remote_lookup/providers/custom_event_remote_lookup_provider/id_type.schemas";
import { itemTypeOutputSchema } from "../../../../cross_type/braze/remote_lookup/providers/custom_event_remote_lookup_provider/item_type.schemas";
import { filtersTypeSchema } from "../../../../cross_type/braze/remote_lookup/providers/custom_event_remote_lookup_provider/filters_type.schemas";

export type CustomEventRemoteLookupId = IdType;
export type CustomEventRemoteLookupItem = ItemTypeOutput;
export type CustomEventRemoteLookupFilters = FiltersType;

export type CustomEventRemoteLookupProvider = RemoteLookupProvider<
  CustomEventRemoteLookupId,
  CustomEventRemoteLookupItem,
  CustomEventRemoteLookupFilters
>;

// The casts absorb zod's invariance over nullable/optional object properties;
// the schemas and interfaces are generated from the same source schema, so the
// shapes are exact.
export const customEventRemoteLookupValidators = {
  id: idTypeSchema as z.ZodType<CustomEventRemoteLookupId>,
  item: itemTypeOutputSchema as z.ZodType<CustomEventRemoteLookupItem>,
  filters: filtersTypeSchema as z.ZodType<CustomEventRemoteLookupFilters>,
};
